<script>
	import { onMount } from 'svelte';
	import { toast_message } from '../../utils/toast_message.js';
    import { domain_code_store } from '../../stores.js';


	export let params = {};
    let domain_code = '';
    domain_code_store.subscribe(value => { domain_code = value; });

	onMount(async () => {
		if (params.token) {
			localStorage.setItem('HoyToKenTy', 'Token');
            localStorage.setItem('HoyToKenTo', params.token);
			localStorage.setItem('HoyDoMainCode', domain_code);
            window.location.href = '/';
		} else {
			toast_message(false, 'Invalid request', 3000);
		}
	});
</script>

<div style="width: 100%;height: 100%;text-align: center;margin-top: 30px;">
	<h1>Redirecting...</h1>
</div>